import Entitlements from '../constants/entitlements';

export const hasAdvancedFiltersEntitlement = (entitlements) => {
    return !!entitlements?.includes(Entitlements.ADVANCED_FILTERS);
};

